import {Command} from "./Command";
import {LooseGamePlay} from "../model/game-play";
import {PlayType} from "../model/playType";

export class SetPlayTypeCommand implements Command {
  constructor(
    private gamePlay: LooseGamePlay,
    private playType: PlayType
  ) { }

  execute() {
    console.log('COMMAND SetPlayTypeCommand', this.playType)
    this.gamePlay.playType = this.playType
  }
}
